import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHasPermission } from "../../../../hooks/useHasPermission";
import { startUIShowModulesCount } from "../../../../redux/actions/administrador/ui/ui";
import { IconApp } from "../../../IconApp";
import { NavLinkApp } from "../../../NavLinkApp";
import SidebarNavAccordion from "../../../SidebarNavAccordion";

export const Modules_Academic = () => {
    const dispatch = useDispatch();
    const { hasPermission } = useHasPermission();
    const { color_text_menu_accordion } = useSelector((state) => state.config);

    // const { user } = useSelector((state) => state.auth);

    const canShowAccordion = hasPermission([
        "READ_STUDENTS_DETAIL",
        "SCHOOL_GROUPS",
        "CLARIFICATIONS",
        "READ_ADMITIONS_LIST",
        "READ_STUDENTS_LIST",
        "SURVEYS",
        "ACADEMIC_EVENTS",
        "EXAMS",
        "SURVEYS_RESULTS",
        "DIPLOMA_SCHEDULES",
        "TESIS_AND_UAIS_SUBJECTS",
        "EXTRACURRICULAR_SUBJECTS",
        "EARLY_INTERVENTION",
        "ATTENDANCE_ROUNDS",
    ]);

    useEffect(() => {
        if (canShowAccordion) {
            dispatch(startUIShowModulesCount("Modules_Academic"));
        }
    }, [canShowAccordion]);

    return (
        // Los permisos que agregues en este nivel van a determinar cuando se renderiza el dropdown de control escolar
        <div>
            {canShowAccordion && (
                <SidebarNavAccordion
                    title={"Gestión Académica"}
                    itemLevel={0}
                    color={color_text_menu_accordion}
                    iconLeftClassName="fa-solid fa-solid fa-book fa-xl"
                >
                    {/* Si agregas un nuevo modulo aqui, con un permiso nuevo, asegurate que este en el elemento padre, aqui arribita ⬆️ */}
                    {hasPermission("CLARIFICATIONS") && (
                        <div>
                            <NavLinkApp
                                name="Aclaraciones"
                                to="/app/school/clarifications"
                                icon={
                                    <IconApp iconClassName="fas fa-message-exclamation c-sidebar-nav-icon"></IconApp>
                                }
                            />
                        </div>
                    )}
                    {hasPermission("READ_ADMITIONS_LIST") && (
                        <NavLinkApp
                            name="Aspirantes"
                            to="/app/students/admission"
                            icon={
                                <IconApp iconClassName="fas fa-calendar-circle-user c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}

                    {hasPermission(["SURVEYS", "SURVEYS_RESULTS"]) && (
                        <NavLinkApp
                            name="Encuestas"
                            to="/app/surveys"
                            icon={
                                <IconApp iconClassName="fas fa-ballot c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}
                    {hasPermission("READ_STUDENTS_LIST") && (
                        <NavLinkApp
                            name="Estudiantes"
                            to="/app/students"
                            icon={
                                <IconApp iconClassName="fas fa-user-graduate c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}
                    {hasPermission(["ACADEMIC_EVENTS"]) && (
                        <NavLinkApp
                            name="Eventos académicos"
                            to="/app/academic_events"
                            icon={
                                <IconApp iconClassName="fas fa-calendar-star c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}
                    {hasPermission(["EXAMS"]) && (
                        <NavLinkApp
                            name="Exámenes"
                            to="/app/exams"
                            icon={
                                <IconApp iconClassName="fas fa-ballot-check c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}
                    {hasPermission("SCHOOL_GROUPS") && (
                        <NavLinkApp
                            name="Grupos académicos"
                            to="/app/operators/academicgroups"
                            icon={
                                <IconApp iconClassName="fas fa-users c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}
                    {hasPermission("DIPLOMA_SCHEDULES") && (
                        <NavLinkApp
                            name="Horarios de Diplomados"
                            to="/app/operators/diploma-schedules"
                            icon={
                                <IconApp iconClassName="fas fa-file-certificate c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}
                    {hasPermission("EARLY_INTERVENTION") && (
                        <NavLinkApp
                            name="Intervención temprana"
                            to="/app/operators/early-interventions"
                            icon={
                                <IconApp iconClassName="fa-solid fa-watch c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}
                    {hasPermission("TESIS_AND_UAIS_SUBJECTS") && (
                        <NavLinkApp
                            name="Materias de Tesis y UAIs"
                            to="/app/operators/tesis-and-uais-subjects"
                            icon={
                                <IconApp iconClassName="fas fa-square-7 c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}
                    {hasPermission("EXTRACURRICULAR_SUBJECTS") && (
                        <NavLinkApp
                            name="Materias extracurriculares"
                            to="/app/operators/extracurricular-subjects"
                            icon={
                                <IconApp iconClassName="fas fa-basketball c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}
                    {hasPermission("ATTENDANCE_ROUNDS") && (
                        <NavLinkApp
                            name="Rondines clases"
                            to="/app/operators/attendance-rounds"
                            icon={
                                <IconApp iconClassName="fas fa-clipboard-check c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}
                </SidebarNavAccordion>
            )}
        </div>
    );
};
